/* eslint-disable quotes */
import React from "react";

function Placeholder() {
  return (
    <div>
      <h3
        style={{
          textAlign: "center",
          backgroundColor: "white",
          color: "black",
        }}
      >
        Please note that the current version hosted on the production link is
        merely a frontend prototype and does not reflect the entirety of the
        project.
      </h3>
    </div>
  );
}

export default Placeholder;
